// Domain types for BioAvail — Bioavailability & Relative Bioavailability Calculator.
// Mirrors PSD §3 verbatim.
// ── Study & Calculation Mode ──────────────────────────────────────────
export var CalculationMode;
(function (CalculationMode) {
    CalculationMode["Absolute"] = "absolute";
    CalculationMode["Relative"] = "relative";
})(CalculationMode || (CalculationMode = {}));
export var StudyType;
(function (StudyType) {
    StudyType["SingleDose"] = "single_dose";
    StudyType["SteadyState"] = "steady_state";
})(StudyType || (StudyType = {}));
export var RouteOfAdministration;
(function (RouteOfAdministration) {
    RouteOfAdministration["IV"] = "IV";
    RouteOfAdministration["Oral"] = "oral";
    RouteOfAdministration["Subcutaneous"] = "sc";
    RouteOfAdministration["Intramuscular"] = "im";
    RouteOfAdministration["Sublingual"] = "sublingual";
    RouteOfAdministration["Topical"] = "topical";
    RouteOfAdministration["Other"] = "other";
})(RouteOfAdministration || (RouteOfAdministration = {}));
export var ArmRole;
(function (ArmRole) {
    ArmRole["Test"] = "test";
    ArmRole["Reference"] = "reference";
})(ArmRole || (ArmRole = {}));
export var AnalyteType;
(function (AnalyteType) {
    AnalyteType["Parent"] = "parent";
    AnalyteType["Metabolite"] = "metabolite";
})(AnalyteType || (AnalyteType = {}));
export var BcsClass;
(function (BcsClass) {
    BcsClass["I"] = "I";
    BcsClass["II"] = "II";
    BcsClass["III"] = "III";
    BcsClass["IV"] = "IV";
})(BcsClass || (BcsClass = {}));
// ── AUC & Integration ─────────────────────────────────────────────────
export var AucInterval;
(function (AucInterval) {
    AucInterval["ZeroToT"] = "0-t";
    AucInterval["ZeroToInf"] = "0-inf";
    AucInterval["Interval"] = "interval";
    AucInterval["ZeroToTau"] = "0-tau";
})(AucInterval || (AucInterval = {}));
export var TrapezoidalRule;
(function (TrapezoidalRule) {
    TrapezoidalRule["LinearUpLogDown"] = "linear_up_log_down";
    TrapezoidalRule["LinearTrapezoidal"] = "linear";
    TrapezoidalRule["LinearLog"] = "linear_log";
})(TrapezoidalRule || (TrapezoidalRule = {}));
export var BlqRule;
(function (BlqRule) {
    BlqRule["M1"] = "M1";
    BlqRule["M2"] = "M2";
})(BlqRule || (BlqRule = {}));
// ── Units ─────────────────────────────────────────────────────────────
export var ConcentrationUnit;
(function (ConcentrationUnit) {
    ConcentrationUnit["NgPerMl"] = "ng/mL";
    ConcentrationUnit["UgPerMl"] = "\u00B5g/mL";
    ConcentrationUnit["UgPerL"] = "\u00B5g/L";
    ConcentrationUnit["MgPerL"] = "mg/L";
    ConcentrationUnit["NmolPerL"] = "nmol/L";
})(ConcentrationUnit || (ConcentrationUnit = {}));
export var TimeUnit;
(function (TimeUnit) {
    TimeUnit["Hour"] = "h";
    TimeUnit["Minute"] = "min";
    TimeUnit["Day"] = "d";
})(TimeUnit || (TimeUnit = {}));
export var DoseUnit;
(function (DoseUnit) {
    DoseUnit["Mg"] = "mg";
    DoseUnit["Ug"] = "\u00B5g";
    DoseUnit["G"] = "g";
})(DoseUnit || (DoseUnit = {}));
// ── Validation & Warnings ─────────────────────────────────────────────
export var WarningSeverity;
(function (WarningSeverity) {
    WarningSeverity["Block"] = "block";
    WarningSeverity["Warn"] = "warn";
    WarningSeverity["Info"] = "info";
})(WarningSeverity || (WarningSeverity = {}));
export var WarningCode;
(function (WarningCode) {
    WarningCode["UnitMismatch"] = "unit_mismatch";
    WarningCode["NegativeInput"] = "negative_input";
    WarningCode["FExceedsOne"] = "f_exceeds_one";
    WarningCode["HighExtrapolation"] = "high_extrapolation";
    WarningCode["LowTerminalR2"] = "low_terminal_r2";
    WarningCode["NegativePredictedConc"] = "negative_pred_c";
    WarningCode["SamplingInadequate"] = "sampling_inadequate";
    WarningCode["WashoutInsufficient"] = "washout_insufficient";
    WarningCode["DoseMatchReminder"] = "dose_match";
    WarningCode["AssayBasisReminder"] = "assay_basis";
    WarningCode["AnalyteMismatch"] = "analyte_mismatch";
    WarningCode["MissingLloq"] = "missing_lloq";
    WarningCode["FlipFlopKinetics"] = "flip_flop_kinetics";
    WarningCode["PkInconsistentAcrossArms"] = "pk_inconsistent_across_arms";
})(WarningCode || (WarningCode = {}));
//# sourceMappingURL=domain.js.map